import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18207683"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "race-position-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "up-arrow",
  style: {"opacity":"0"}
}, null, -1))
const _hoisted_3 = { class: "race-position" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "down-arrow",
  style: {"opacity":"0"}
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_6 = { class: "team-badge" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "abbreviation" }
const _hoisted_9 = ["data-content"]
const _hoisted_10 = {
  key: 1,
  class: "value",
  "data-content": "OUT"
}

interface Props {
        driver: {
            racingNumber: string;
            abbreviation: string;
            team: {
                name: string;
                logoFile: string;
            };
            position: [number, number];
            trackPosition: number;
            interval: string;
            stopped: boolean;
        };
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TowerDriver',
  props: {
    driver: null
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["driver", __props.driver.stopped ? 'stopped' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.driver.trackPosition), 1),
      _hoisted_4
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("img", {
        src: __props.driver.team.logoFile
      }, null, 8, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, _toDisplayString(__props.driver.abbreviation), 1),
    (!__props.driver.stopped)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "value",
          "data-content": 
                __props.driver.interval.split(' ')[0] == 'LAP'
                    ? 'INTERVAL'
                    : __props.driver.interval
            
        }, _toDisplayString(__props.driver.interval.split(" ")[0] == "LAP"
                    ? "INTERVAL"
                    : __props.driver.interval), 9, _hoisted_9))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, "OUT"))
  ], 2))
}
}

})